import { put, takeLatest } from "redux-saga/effects";
import {
    appNotify,
    fetchOpportunityHistoryTableDetails,
    setIsOpportunityHistoryDetailsModalLoading,
    setIsOpportunityHistoryDetailsModalOpen,
    setOpportunityHistoryDetailsEditHistories,
    setOpportunityHistoryDetailsStatusHistories,
    setOpportunityHistoryDetailsTaxesHistories,
    setOpportunityHistoryDetailsCrmSubmissionHistories,
    setOpportunityHistoryDetailsAllocationHistories,
    setOpportunityHistoryDetailsCrmReceiptHistories,
    setOpportunityHistoryDetailsIcbmOrderHistories,
    setOpportunityHistoryDetailsValuationHistories,
    setOpportunityHistoryProformaInputsContainers,
    setOpportunity,
    setOpportunityHistoryTransactionOpportunityHistories,
    setOpportunityHistoryDetailsCompHistories,
    setOpportunityHistoryDetailsImportSaveHistories,
    setOpportunityHistoryDetailsImportPropMasterHistories,
    setOpportunityHistoryDetailsImportHomesHistories,
    setOpportunityHistoryDetailsRegionsAndIndicativesHistories,
    setOpportunityHistoryDetailsMarketHistories,
    setOpportunityHistoryDetailsReapirEstimateHistories,
    setOpportunityHistoryDetailsExpectedSalesPriceHistories,
    setOpportunityHistoryDetailsInsurancesHistories,
    setOpportunityHistoryDetailsProspects,
    setOpportunityHistoryDetailsRejectedImports,
    setOpportunityHistoryDetailsAssignmentHistory,
    setOpportunityHistoryDetailsUnderwriteStatusHistory
} from "../../store/actions";
import { getWithToken } from "../../api/network";

export function* getOpportunityHistoryTableDetailsSaga() {
    yield takeLatest(fetchOpportunityHistoryTableDetails, function* ({ payload }) {

        yield put(setIsOpportunityHistoryDetailsModalLoading(true));
        yield put(setIsOpportunityHistoryDetailsModalOpen(true));

        let url, response, data;
        switch (payload.eventSummary.detailsTypeDisplay) {
            case 'TransactionOpportunityEditHistories':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetEditHistoriesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsEditHistories(data));
                break;
            case 'OpportunityStatusHistories':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetStatusHistoriesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsStatusHistories(data));
                break;
            case 'Taxes':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetTaxesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsTaxesHistories(data));
                break;
            case 'CrmSubmissions':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetCrmSubmissionsByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsCrmSubmissionHistories(data));
                break;
            case 'Allocations':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetAllocationsByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsAllocationHistories(data));
                break;
            case 'CrmReceipts':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetCrmReceiptsByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsCrmReceiptHistories(data));
                break;
            case 'ImportSave':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetImportSaveByImportPropertyId/${payload.eventSummary.tableId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsImportSaveHistories(data));
                break;
            case 'PropertyMaster':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetImportPropertyMasterByImportPropertyId/${payload.eventSummary.tableId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsImportPropMasterHistories(data));
                break;
            case 'AddOrUpdateHome':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetAddOrUpdateHomeByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsImportHomesHistories(data));
                break;
            case 'GetRegionsAndIndicatives':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetRegionsAndIndicativesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsRegionsAndIndicativesHistories(data));
                break;
            case 'GetMarket':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetMarketsByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsMarketHistories(data));
                break;
            case 'UpdateIcbm':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetIcbmOrdersByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsIcbmOrderHistories(data));
                break;
            case 'UpdateRepairs':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetRepairEstimatesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsReapirEstimateHistories(data));
                break;
            case 'UpdateExpectedSalesPrices':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetExpectedSalesPricesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsExpectedSalesPriceHistories(data));
                break;
            case 'GetInsurance':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetInsurancesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsInsurancesHistories(data));
                break;
            case 'UpdateComps':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetCompsByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsCompHistories(data));
                break;
            case 'ValuationHistory':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetValuationHistoriesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsValuationHistories(data));
                break;
            case 'TransactionOpportunityHistories':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetTransactionOpportunityHistoriesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryTransactionOpportunityHistories(data));
                break;
            case 'AssembleProformaInputs':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetProformaInputsContainerByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryProformaInputsContainers(data));
                break;
            case 'SaveOpportunity':
                url = yield `/api/underwrite/workflow/transactionOpportunity/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunity(data));
                break;
            case 'SyncProspects':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetProspectById/${payload.eventSummary.tableId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsProspects(data));
                break;
            case 'RejectedImports':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetRejectedImportsById/${payload.eventSummary.tableId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsRejectedImports(data));
                break;
            case 'AssignmentHistory':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetAssignmentHistoriesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsAssignmentHistory(data));
                break;
            case 'UnderwriteStatusChange':
                url = yield `/api/underwrite/workflow/opportunityHistory/details/GetUnderwriteStatusHistoriesByTxnOppId/${payload.txnOppId}`;
                response = yield getWithToken(url);
                data = yield response.json();
                yield put(setOpportunityHistoryDetailsUnderwriteStatusHistory(data));
                break;
            default:
                yield put(appNotify(`TODO: ${payload.eventSummary.detailsTypeDisplay} details`, 'warning'));
                yield put(setIsOpportunityHistoryDetailsModalOpen(false));
                break;
        }

        yield put(setIsOpportunityHistoryDetailsModalLoading(false));
    });
}